import { CSSProperties } from 'react';
import { theme } from '../../theme';

export const addressInfoBoxStyles = {
  container: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing.extraSmall,
    padding: `${theme.spacing.small}px 0`,
    fontFamily: theme.typography.fontFamily,
  } as CSSProperties,

  indicator: {
    width: theme.spacing.mediumLarge,
    height: theme.spacing.mediumLarge,
    minWidth: theme.spacing.mediumLarge,
    borderRadius: '50%',
    backgroundColor: theme.colors.button.primary,
    marginTop: theme.spacing.micro,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  } as CSSProperties,

  indicatorDot: {
    width: theme.sizes.dot.width,
    height: theme.sizes.dot.height,
    borderRadius: '50%',
    backgroundColor: theme.colors.white,
  } as CSSProperties,

  content: {
    flex: 1,
  } as CSSProperties,

  text: {
    fontSize: theme.typography.fontSize.sm,
    fontWeight: theme.typography.fontWeight.normal,
    lineHeight: theme.typography.lineHeight.sm,
    color: theme.colors.label,
    fontFamily: theme.typography.fontFamily,
    margin: 0,
  } as CSSProperties,

  addressBold: {
    fontWeight: theme.typography.fontWeight.bold,
  } as CSSProperties,
};
